import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'María G.',
  age: 34,
  country: 'Argentina',
  text: 'Antes era un dolor de cabeza pensar qué mandarles. Con este sistema organizo las viandas de toda la semana en un rato el domingo. ¡Me salvó la vida y gané muchísimo tiempo!'
}, {
  name: 'Laura P.',
  age: 29,
  country: 'México',
  text: 'No puedo creer que mis hijos estén comiendo verduras sin quejarse. Las recetas para esconder vegetales son magia pura. Las croquetas son sus favoritas ahora.'
}, {
  name: 'Carolina R.',
  age: 38,
  country: 'Colombia',
  text: 'Los tips para freezar me cambiaron la rutina. Ahora siempre tengo algo listo en el congelador para esos días que no tengo tiempo de nada. Vale cada centavo.'
}, {
  name: 'Valentina S.',
  age: 31,
  country: 'Chile',
  text: "El alivio mental de no tener que pensar '¿qué cocino hoy?' no tiene precio. Las ideas son súper prácticas y con ingredientes que siempre tengo en casa."
}, {
  name: 'Sofía M.',
  age: 36,
  country: 'España',
  text: 'La checklist semanal es increíble. Pasé de improvisar y estresarme todas las mañanas a tener todo bajo control. Súper recomendado para cualquier mamá ocupada.'
}];
export function Testimonials() {
  return <section className="bg-white py-16 px-4" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <motion.h2 className="text-3xl md:text-5xl font-black text-center text-brand-darkGreen mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-177">
          Lo que dicen otras mamás
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-brand-cream p-6 rounded-2xl shadow-md border border-brand-beige" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-179">
              <div className="flex text-brand-yellow mb-4 text-xl" data-id="element-180">★★★★★</div>
              <p className="text-gray-700 italic mb-6" data-id="element-181">"{testimonial.text}"</p>
              <div className="flex items-center gap-3" data-id="element-182">
                <div className="w-10 h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold text-lg" data-id="element-183">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-184">
                  <p className="font-bold text-brand-darkGreen" data-id="element-185">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-186">
                    {testimonial.age} años, {testimonial.country}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}